/* stylelint-disable value-no-vendor-prefix */
/* stylelint-disable property-no-vendor-prefix */

import { vars } from '@etg/wings';
import { css, cx, mediaQueries } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const itemStyles = imagery => css`
  display: flex;

  & > * {
    width: 100%;
  }

  &:nth-child(1) {
    grid-area: picture;
    /* stylelint-disable property-no-vendor-prefix */
    -ms-grid-column: 1;
    -ms-grid-column-span: 1;
    -ms-grid-row: 1;
    -ms-grid-row-span: 1;
    margin: ${imagery ? '10px' : '0'};
  }

  &:nth-child(2) {
    grid-area: desc;
    -ms-grid-column: ${imagery ? '2' : '1'};
    -ms-grid-column-span: 1;
    -ms-grid-row: 1;
    -ms-grid-row-span: 1;
    padding: 16px;
  }

  &:nth-child(3) {
    flex-direction: column;
    grid-area: select;
    -ms-grid-column: 1;
    -ms-grid-column-span: 2;
    -ms-grid-row: ${imagery ? '2' : '1'};
    -ms-grid-row-span: 1;
  }

  @media ${mediaQueries.medium.up} {
    &:nth-child(1) {
      -ms-grid-column: 1;
      -ms-grid-column-span: 1;
      -ms-grid-row: 1;
      -ms-grid-row-span: 2;
      margin: 0;
    }
    &:nth-child(2) {
      min-height: 85px;
    }
    &:nth-child(3) {
      -ms-grid-column: 2;
      -ms-grid-column-span: 2;
      -ms-grid-row: 2;
      -ms-grid-row-span: 1;
    }
    /* stylelint-enable property-no-vendor-prefix */
  }
`;
const selectionStyles = selection => css`
  ${selection ? `'desc desc'
    'select select'` : `'desc desc'
    'desc desc'`}
`;
const boxStyles = (imagery, selectionCss) => css`
  background-color: #fff;
  border-radius: ${vars.card.borderRadius};
  display: grid;
  -ms-grid-rows: auto;
  grid-template-areas: ${imagery ? `'picture desc'
    'select select'` : `${selectionCss}`};
  grid-template-columns: ${imagery ? `110px auto` : `50% 50%`};
  grid-template-rows: auto; /* stylelint-disable-line */
  ${imagery && 'display: -ms-grid; -ms-grid-columns: 110px 1fr;'}
  padding-bottom: 0;
  position: relative;

  @media ${mediaQueries.medium.up} {
    grid-template-areas: ${imagery && `'picture desc'
   'picture select'`};
    grid-template-columns: ${imagery ? `46% auto` : `50% 50%`};
    ${imagery && '-ms-grid-columns: 46% 1fr;'};
    padding: 0;
  }
`;
const ProductBox = _ref => {
  let {
    description,
    imagery,
    selection,
    testId
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cx(boxStyles(imagery, selectionStyles(selection)), 'product-box'),
    "data-productbox": true,
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx("div", {
      className: itemStyles(imagery),
      children: imagery
    }), /*#__PURE__*/_jsx("div", {
      className: itemStyles(imagery),
      children: description
    }), /*#__PURE__*/_jsx("div", {
      className: itemStyles(imagery),
      children: selection
    })]
  });
};
export default ProductBox;
//# sourceMappingURL=ProductBox.js.map